export const CarApi = 'wx/car/' // 会员车辆信息
